"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLightningTalksCalendarLink = exports.getWorkshopCalendarLink = exports.createCalendarLink = void 0;

var _luxon = require("luxon");

var ADD_EVENT_ID = 'aypbtNBcPzBIdDvukmvT46093';

var createEventTitle = function createEventTitle(speakers, talk, eventName) {
  var speakersStr = speakers.map(function (s) {
    return s.name;
  }).join(', ');

  try {
    return "".concat(speakersStr || '').concat(speakersStr ? ' - ' : '', "\"").concat(talk.title, "\"").concat(eventName ? " at ".concat(eventName) : '');
  } catch (err) {
    return eventName;
  }
};

var createCalendarLink = function createCalendarLink(speakers, activities, _ref) {
  var calendarEventDescription = _ref.calendarEventDescription,
      calendarEventName = _ref.calendarEventName,
      conferenceStart = _ref.conferenceStart,
      conferenceEnd = _ref.conferenceEnd;
  var description = encodeURIComponent(calendarEventDescription);

  try {
    var talk = activities && activities.talks[0];
    var title = encodeURIComponent(createEventTitle(speakers, talk, calendarEventName));

    var localDate = _luxon.DateTime.fromISO(talk.isoDate || talk.timeString);

    return "https://www.addevent.com/dir/?client=".concat(ADD_EVENT_ID, "&start=").concat(localDate.toFormat('yyyy/MM/dd HH:mm'), "&duration=").concat(talk.duration, "&title=").concat(title).concat(description ? "&description=".concat(description) : '', "&timezone=").concat(localDate.zoneName, "&alarm=15");
  } catch (err) {
    // Fallback whole day event
    var localDateEventStart = _luxon.DateTime.fromISO(conferenceStart);

    var localDateEventEnd = _luxon.DateTime.fromISO(conferenceEnd);

    if (calendarEventName && conferenceStart && conferenceEnd) {
      return "https://www.addevent.com/dir/?client=".concat(ADD_EVENT_ID, "&start=").concat(localDateEventStart.toFormat('yyyy/MM/dd HH:mm'), "&end=").concat(localDateEventEnd.toFormat('yyyy/MM/dd HH:mm'), "&title=").concat(calendarEventName).concat(description ? "&description=".concat(description) : '', "&timezone=").concat(localDateEventStart.zoneName, "&all_day_event=true");
    }

    return null;
  }
};

exports.createCalendarLink = createCalendarLink;

var getWorkshopCalendarLink = function getWorkshopCalendarLink(_ref2, calendarEventDescription) {
  var title = _ref2.title,
      isoDate = _ref2.isoDate,
      duration = _ref2.duration;

  var localDate = _luxon.DateTime.fromISO(isoDate);

  var encodedTitle = encodeURIComponent("Workshop: ".concat(title));
  var description = encodeURIComponent(calendarEventDescription);
  return "https://www.addevent.com/dir/?client=".concat(ADD_EVENT_ID, "&start=").concat(localDate.toFormat('yyyy/MM/dd HH:mm'), "&duration=").concat(duration * 60, "&title=").concat(encodedTitle).concat(calendarEventDescription ? "&description=".concat(description) : '', "&timezone=").concat(localDate.zoneName, "&alarm=15");
};

exports.getWorkshopCalendarLink = getWorkshopCalendarLink;

var getLightningTalksCalendarLink = function getLightningTalksCalendarLink(_ref3) {
  var title = _ref3.title,
      isoDate = _ref3.isoDate,
      duration = _ref3.duration,
      lightningTalks = _ref3.lightningTalks;

  var localDate = _luxon.DateTime.fromISO(isoDate);

  var encodedTitle = encodeURIComponent("".concat(title));
  var description = encodeURIComponent(lightningTalks.reduce(function (acc, cur) {
    var speakers = cur.speakers ? cur.speakers.map(function (s) {
      return s.name;
    }).join(', ') : cur.speaker;
    var next = "\"".concat(cur.title, "\" by ").concat(speakers);

    if (acc) {
      return "".concat(acc, ", ").concat(next);
    }

    return next;
  }, ''));
  return "https://www.addevent.com/dir/?client=".concat(ADD_EVENT_ID, "&start=").concat(localDate.toFormat('yyyy/MM/dd HH:mm'), "&duration=").concat(duration, "&title=").concat(encodedTitle).concat(lightningTalks.length ? "&description=".concat(description) : '', "&timezone=").concat(localDate.zoneName, "&alarm=15");
};

exports.getLightningTalksCalendarLink = getLightningTalksCalendarLink;